import styled from 'styled-components'

import Button from '@components/atoms/Button'
import { IconRight } from '@components/atoms/Button/Button.styles'
import InputCheckbox from '@components/atoms/Form/InputCheckbox'
import InputText from '@components/atoms/Form/InputText'

export const Root = styled.div`
  background-color: ${({ theme }) => theme.palette.default.white};
`

export const StyledCouponItem = styled.div`
  border-radius: 1rem;
  border: 1px solid ${({ theme }) => theme.palette.default.grey};
  display: flex;
  flex-direction: column;
  height: auto;
  margin-bottom: ${(props) => props.theme.margin.default};
  position: relative;
  overflow: hidden;
  img {
    width: 100%;
    height: auto;
  }
  &:hover {
    cursor: pointer;
  }
`

export const CloseIconWrapper = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 0.65rem;
  top: 0.65rem;
  z-index: 10;
`

export const StyledLabel = styled.label`
  font-weight: bold;
  display: block;
  padding: ${(props) => props.theme.margin.small};
  padding-right: 50px;
`

export const StyledButton = styled(Button)`
  font-size: 1rem;
  margin-bottom: 0;
  margin-right: 0;
  padding: 0.5rem 1rem;
  ${IconRight} {
    display: none;
  }
  @media (min-width: ${({ theme }) => theme.device.desktop}) {
    ${IconRight} {
      display: block;
    }
  }
`

export const StyledButtonMobile = styled(StyledButton)`
  display: flex;
  margin: auto;
  margin-bottom: ${(props) => props.theme.margin.default};
  @media (min-width: ${({ theme }) => theme.device.desktop}) {
    display: none;
  }
`
export const StyledButtonDesktop = styled(StyledButton)`
  display: none;
  @media (min-width: ${({ theme }) => theme.device.desktop}) {
    display: flex;
  }
`

export const StyledInputText = styled(InputText)`
  margin-bottom: 0;
  flex: 1;
  padding-right: ${(props) => props.theme.margin.small};
`

export const StyledInputCheckbox = styled(InputCheckbox)`
  margin-bottom: ${(props) => props.theme.padding.small};
`

export const InputButton = styled.div`
  align-items: flex-end;
  display: flex;
  margin-bottom: ${(props) => props.theme.padding.small};
  padding: 0 ${(props) => props.theme.margin.small};
`

export const Checkboxes = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${(props) => props.theme.margin.small};
`

export const FormResult = styled.div<{ success: boolean }>`
  align-items: center;
  color: ${(props) => props.theme.palette.default.black};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding-top: ${(props) => props.theme.padding.small};
`
